<template>
  <article id="article-tradingview">
    <section id="section-tradingview">
      <component v-if="name && type" :is="componentId" :name="name" :mode="'advanced'"></component>
    </section>
  </article>
</template>

<script>
export default {
  components: {
    FundTradingviewChart: () => import("../../components/miniapp/global/FundTradingviewChart"),
    StockTradingviewChart: () => import("../../components/miniapp/global/StockTradingviewChart"),
    IndiceTradingviewChart: () => import("../../components/miniapp/global/IndiceTradingviewChart"),
    GoldTradingviewChart: () => import("../../components/miniapp/global/GoldTradingviewChart"),
    GoldSpotTradingviewChart: () => import("../../components/miniapp/global/GoldSpotTradingviewChart")
  },
  computed: {
    componentId() {
      switch (this.type) {
        case "fund":
          return "FundTradingviewChart"
        case "stock":
          return "StockTradingviewChart"
        case "indice":
          return "IndiceTradingviewChart"
        case "gold":
          return "GoldTradingviewChart"
        case "gold_spot":
          return "GoldSpotTradingviewChart"
        default:
          break
      }
    },
    name() {
      return this.$route.query.name
    },
    type() {
      return this.$route.query.type
    },
    getOS() {
      return this.$liff.getOS()
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
#section-tradingview {
  padding-left: 0;
  padding-right: 0;
}
</style>